/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { FormControl, FormGroup } from "@material-ui/core";
import TaskItemCheckbox from "./TaskItemCheckbox";
import { Search } from "lucide-react";
import { Input } from "../../../../components/ui/input";

const TaskLists = (props) => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [taskList, setTaskList] = React.useState([]);

  useEffect(() => {
    setTaskList(props.taskList);
  }, [props.taskList]);

  let filterdSearchList = taskList?.filter((titem) =>
    String(titem?.title)
      .toLowerCase()
      ?.includes(String(searchTerm).toLowerCase())
  );
  return (
    <div>    
      <div className="stepSectionTitle color-black d-flex flex-center mv-0">
          {props?.search === true && (
          <div className="mb-4 flex items-center w-100">
            <Search className="w-4 h-4 mr-8 text-gray-400" />
           <Input
            name="searchTask"
            id="searchTask"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
            placeholder="Search standard tasks..." 
            disabled={props?.disabled}
            />
            </div>
          )}
      </div>
      {filterdSearchList?.length > 0 ? (
        <div className={`stepSectionContent pl-15 scrollable`}>
          <FormControl component="div" className={"checkboxfieldwrap w-100"}>

            <div className={"checkboxGroupwrap column-2"}>
              <FormGroup row>
                {filterdSearchList.map((TaskItem, index) => (
                  <TaskItemCheckbox
                    key={"taskitemcomp" + index}
                    index={index}
                    Task={TaskItem}
                    selected={props?.checkselected(TaskItem?.taskId ?? TaskItem?.id)}
                    handleTasksCheckChange={props?.handleTasksCheckChange}
                    removeTask={props?.removeTask}
                    onEditTask={props?.onEditTask}
                    shifttitle={props.shifttitle}
                    disabled={props?.disabled}
                  />
                ))}
              </FormGroup>
            </div>

          </FormControl>
        </div>
      ) : (
        <div>
          {/* No {props.custom === true ? 'Custom' : 'Standard'} Tasks Found */}
        </div>
      )}
    </div>
  );
};

export default TaskLists;
